// extracted by mini-css-extract-plugin
export default {"contentPageBody":"content-page-body__content-page-body__0yU0Z","pageHeightBody":"content-page-body__page-height-body__yKj5k","widthLimited":"content-page-body__width-limited__PmNty"};